import {
    Button,
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { IconLabelSwitch } from "../../../iconSwitch/IconLabelSwitch";
import { CustomWidthTooltip } from "../../../tooltips/CustomWidthTooltip";
import Service from "./NewVersionService";
import React from "../../../labels/Version";
import GridInputRow from "../../../form-grids/GridInputRow";
import { GridCloseIcon } from "@material-ui/data-grid";
import { DefaultDatagrid } from "../../../datagrid/DefaultDatagrid";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";

const useStyles = makeStyles(() => ({
    icon: {
        height: 20,
        width: 20,
        fill: "#fff",
    },
    link: {
        borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
        paddingTop: 8,
    },
    title: {
        fontStyle: "bold",
        textAlign: "center",
    },
    pacLogo: {
        //marginRight: theme.spacing(2),
        height: "50px",
        width: "75%",
        marginTop: "85px",
        marginLeft: "40px",
    },
    flexTop: {
        alignItems: "flexTop",
    },
    colorButton1: {
        backgroundColor: "rgba(173,185,202)",
        height: 300,
        paddingTop: 100,
        paddingLeft: 80,
        marginLeft: 3,
    },
    colorButton2: {
        backgroundColor: "rgba(180,199,231)",
        height: 150,
    },
    colorButton3: {
        backgroundColor: "rgba(143,170,220)",
        height: 150,
    },
    colorButton4: {
        backgroundColor: "rgba(218,227,243)",
        height: 150,
    },
    colorButton5: {
        backgroundColor: "rgba(0,32,96)",
        height: 150,
    },
    colorButton6: {
        backgroundColor: "rgba(143,170,220)",
        height: 150,
    },
    colorButton7: {
        backgroundColor: "rgba(68,114,196)",
        height: 150,
    },
    colorButton8: {
        backgroundColor: "rgba(143,170,220)",
        height: 250,
        marginLeft: 6,
    },
    divider: {
        marginTop: 30,
    },
    separateIcons: {
        padding: 2,
        marginBottom: 15,
    },
    rotateButtons: {
        transform: "rotate(-43deg)",
        marginLeft: "30px",
        marginTop: "-190px",
        paddingLeft: 25,
    },
    rotateIcon: {
        transform: "rotate(45deg)",
    },
    scrollClip: {
        overflow: "clip",
    },
    contDescription: {
        color: "rgba(128,128,128)",
        fontSize: 18,
        fontWeight: "bold",
    },
    contData: {
        color: "rgba(0,32,96)",
        fontSize: 18,
        fontWeight: "bold",
    },
    contList: {
        color: "rgba(52,101,164)",
        fontSize: 18,
        fontWeight: "bold",
    },
    listLink: {
        paddingTop: 5,
        cursor: "pointer",
    },
    maxHeight: {
        maxHeight: 655,
    },
    alginCenter: {
        alignSelf: "center",
        textAlign: "center",
        maxHeight: 50,
        overflow: "hidden",
        paddingRight: 5,
    },
    alignDragDrop: {
        alignSelf: "center",
        marginLeft: "40%",
    },
}));

export const NewVersionDialog = (props) => {

    const classes = useStyles();
    const { t } = useTranslation();

    const initialState = {
        versionId: 0,
        versionNumber: "",
        versionTitle: "",
        versionDate: "",
        patchNotes: "",
    };

    const [sample, setSample] = useState(initialState);
    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(true);
    const [dateVersion, setDateVersion] = useState();
    const [version, setVersion] = useState();
    const [versionId, setVersionId] = useState();

    useEffect(() => {
        if (props.dialogOpen) {
            Service.get(sample)
                .then((response) => {
                    setVersion(response.data[0].versionNumber);
                    setDateVersion(response.data[0].versionDate);
                })
                .catch((e) => { });
        }
    }, [props.dialogOpen]);

    const handleClose = () => {
        props.dialog()
    };

    //   const handleOpenTerms = () => {
    //     setTermsUse(true);
    //     setOpen(false);
    //   };

    const [openNewVersion, setOpenNewVersion] = useState(false);

    const columns = (t) => [
        {
            field: "versionNumber",
            headerTemplate: () => {
                return (
                    <IconLabelSwitch
                        isHeader={true}
                        name="newIcon"
                        labelName="versionNumber"
                    />
                );
            },
            flex: 0.5,
            template: (props) => {
                return (
                    <>
                        <Typography
                            style={{
                                fontWeight: "bold",
                                textAlign: "center",
                            }}
                        >
                            {props.versionNumber}
                        </Typography>
                    </>
                );
            },
        },
        {
            field: "versionTitle",
            headerTemplate: () => {
                return (
                    <IconLabelSwitch
                        isHeader={true}
                        name="versionTitle"
                        labelName="versionTitle"
                    />
                );
            },
            flex: 0.5,
            template: (props) => {
                return (
                    <>
                        <Typography
                            style={{
                                textAlign: "center",
                                fontSize: "14px",
                            }}
                        >
                            {props.versionTitle}
                        </Typography>
                    </>
                );
            },
        },
        {
            field: "versionDate",
            headerTemplate: () => {
                return (
                    <IconLabelSwitch
                        isHeader={true}
                        name="date"
                        labelName="versionDate"
                    />
                );
            },
            flex: 0.5,
            template: (props) => {
                return (
                    <>
                        <Typography
                            style={{
                                textAlign: "center",
                                fontSize: "14px",
                            }}
                        >
                            {props.versionDate}
                        </Typography>
                    </>
                );
            },
        },
        {
            field: "patchNotes",
            headerTemplate: () => {
                return (
                    <IconLabelSwitch
                        isHeader={true}
                        name="message"
                        labelName="patchNotes"
                    />
                );
            },
            flex: 0.5,
            template: ({ patchNotes }) => {
                const splited = patchNotes.split(";");
                return (
                    <>
                        {patchNotes && (
                            <CustomWidthTooltip
                                placement="left"
                                title={
                                    <>
                                        {splited.map((row) => (
                                            <Typography style={{ fontSize: "14px" }}>
                                                {row}
                                            </Typography>
                                        ))}
                                    </>
                                }
                            >
                                <Typography>{patchNotes}</Typography>
                            </CustomWidthTooltip>
                        )}
                    </>
                );
            },
        },
    ];

    const handleOpenNewVersion = () => {
        setOpenNewVersion(true);
        setOpen(false);
        Service.get(sample)
            .then((response) => {
                console.clear();
                setRows(response.data);
            })
            .catch((e) => { });
    };

    return (
        <div>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                onClose={handleClose}
                className={classes.maxHeight}
            >
                <DialogContent className={classes.scrollClip}>
                    <Grid container direction="row" alignItems="flex-start">
                        <Grid md={4}></Grid>
                        <Grid md={7} className={classes.divider}>

                        </Grid>
                        <Grid md={1}>
                            <IconButton aria-label="close" onClick={handleClose}>
                                <GridCloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" alignItems="center" justify="center">
                        <Grid item md={6}>
                            <GridInputRow>
                                <GridInputRow>
                                    <Grid item md={1}>
                                        {" "}
                                    </Grid>
                                    <Grid item md={11} className={classes.divider}>
                                        <GridInputRow>
                                            <Grid item md={2} className={classes.contDescription}>
                                                {t("version")}:
                                            </Grid>
                                            <Grid item md={8} className={classes.contData}>
                                                {version}
                                            </Grid>
                                        </GridInputRow>
                                        <GridInputRow>
                                            <Grid item md={6} className={classes.contDescription}>
                                                {t("releaseDate")}
                                            </Grid>
                                            <Grid item md={6} className={classes.contData}>
                                                {dateVersion}
                                            </Grid>
                                        </GridInputRow>
                                        <GridInputRow>
                                            <Grid item md={2} className={classes.contDescription}>
                                                {t("license")}
                                            </Grid>
                                            <Grid item md={8} className={classes.contData}>
                                                {t("complete")}
                                            </Grid>
                                        </GridInputRow>
                                    </Grid>
                                </GridInputRow>
                                <GridInputRow>
                                    <Grid item md={2}></Grid>
                                    <Grid item md={10}>
                                        <ul className={classes.contList}>
                                            <li
                                                onClick={handleOpenNewVersion}
                                                className={classes.listLink}
                                            >
                                                {t("newVersion")}{" "}
                                            </li>
                                            <li
                                                onClick={"handleOpenTerms"}
                                                className={classes.listLink}
                                            >
                                                {t("termsUse")}
                                            </li>
                                        </ul>
                                    </Grid>
                                </GridInputRow>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item md={7}></Grid>
                                <Grid item md={5}>

                                </Grid>
                            </GridInputRow>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>

            {/*<TermsUseDialog setOpenDialog={termsUse} callBack={handleCallBack} />*/}

            {/*dialog das informa��es da nova vers�o*/}
            <Dialog
                open={openNewVersion}
                maxWidth="md"
                fullWidth
                onClose={handleClose}
            >
                <DialogContent>
                    <Grid container direction="row">
                        <Grid
                            md={11}
                            style={{ fontSize: 30, fontWeight: "bold", textAlign: "center" }}
                        >
                            {t("newVersion")}
                        </Grid>
                        <Grid md={1}>
                            <IconButton aria-label="close" onClick={handleClose}>
                                <GridCloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {rows.length > 0 && (
                        <Grid item xs={12} style={{ marginTop: -30 }}>
                            <DefaultDatagrid
                                dataSource={rows}
                                columns={columns(t)}

                            />
                        </Grid>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};
